import { render, staticRenderFns } from "./crew-advtrxhist.vue?vue&type=template&id=7091aa96&scoped=true"
import script from "./crew-advtrxhist.vue?vue&type=script&lang=js"
export * from "./crew-advtrxhist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7091aa96",
  null
  
)

export default component.exports